import { Pipe, PipeTransform } from '@angular/core';
import { Filter, FilterTypes, StringFilter } from '@models/filter-types';

@Pipe({
    name: 'isStringFilter',
    standalone: false,
})
export class IsStringFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is StringFilter {
        return value?.Type === FilterTypes.StringFilterType;
    }
}
